export const color = '#0E2483'
export const text = `white`